/*
 * Invoice status labels (QA fixes C4/C6, 2026-10-22). The server's values stay
 * as they are ("OverDue", "PartiallyPaid", ...); only what people read changes.
 */

/** Text shown for an invoice status from the invoice list / client billing. */
export const invoiceStatusLabel = (status?: string | null) => {
  switch (status) {
    case "OverDue":
      return "Overdue";
    case "PartiallyPaid":
    case "Partially Paid":
      return "Partially paid";
    default:
      return status || "";
  }
};

/**
 * Work item Billing box: Paid / Partially paid / the invoice's label / Unpaid.
 * A partly paid invoice used to show "Unpaid".
 */
export const workInvoicePayLabel = (invoice: {
  isPaid?: boolean | null;
  total?: number | null;
  balance?: number | null;
  status?: string | null;
}) => {
  const total = invoice.total || 0;
  const balance = invoice.balance ?? total;
  if (invoice.isPaid || balance <= 0.004) return "Paid";
  if (total > 0 && balance < total - 0.004) return "Partially paid";
  return invoice.status || "Unpaid";
};

/**
 * Overdue = the due DAY is before today (QA batch 12, 2026-10-21). An invoice
 * due today is "Not due yet" on its page too, like in the invoice list (the
 * page compared the due date's midnight with the current time).
 */
export const isPastDue = (
  dueDate?: string | Date | null,
  now: Date = new Date(),
): boolean => {
  if (!dueDate) return false;
  const due = new Date(dueDate);
  if (Number.isNaN(due.getTime())) return false;
  const dueDay = new Date(due.getFullYear(), due.getMonth(), due.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return dueDay < today;
};

/**
 * Client page of a billing row's main client (QA batch 12): organizations open
 * /organization/{businessContactId}, individuals /contact/{customerId}?contactId=.
 * null when the row lacks the ids.
 */
export const billingClientLink = (row: {
  customerId?: string | null;
  contactId?: string | null;
  businessContactId?: string | null;
}): string | null => {
  if (row.businessContactId) return `/organization/${row.businessContactId}`;
  if (row.customerId && row.contactId)
    return `/contact/${row.customerId}?contactId=${row.contactId}`;
  return null;
};
